// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N5uj","largestCol":"styles_largestCol__1a9To","smallestCol":"styles_smallestCol__3w41z"};